import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  ArrowUpRight, Brain, CloudRain, Activity, Repeat, Sparkles, Moon,
  HeartPulse, Baby, Users, Flower2, LifeBuoy, Stethoscope, CalendarClock,
  IndianRupee, ShieldCheck, Languages,
} from "lucide-react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import AppointmentDialog from "@/components/AppointmentDialog";
import useSEO from "@/hooks/useSEO";

const HERO = "https://static.prod-images.emergentagent.com/jobs/e1910145-6c8d-4199-9278-87a3c9131c27/images/e4ec91149491ab48dc4695a28a4823f40ae24262863565b5ce2a0f0e55b3c132.jpeg";
const SITE = "https://manasneuropsychiatryhospital.in";

const conditions = [
  { icon: CloudRain, title: "ડિપ્રેશન (હતાશા)", signs: "સતત ઉદાસી, કોઈ કામમાં રસ ન રહેવો, થાક, ઊંઘ અને ભૂખમાં ફેરફાર, અપરાધભાવ, ધ્યાન ન ટકવું, જીવન ટૂંકાવવાના વિચાર.", care: "OPDમાં દવા અને કાઉન્સેલિંગ (CBT) સાથે સારવાર. મોટાભાગના દર્દીઓ ૬થી ૮ અઠવાડિયામાં સ્પષ્ટ સુધારો અનુભવે છે, અને દવા કાયમ માટે લેવી પડતી નથી." },
  { icon: Activity, title: "બાયપોલર (ઉન્માદ–હતાશા)", signs: "ક્યારેક અતિ ઉત્સાહ, ઓછી ઊંઘે પણ તાજગી, વધુ ખર્ચ કે જોખમી નિર્ણય — અને વચ્ચે ઘોર હતાશાના તબક્કા.", care: "લાંબા ગાળાની મૂડ સ્ટેબિલાઈઝર દવા, રોગ વિશે સમજ, ઊંઘનું નિયમન અને નિયમિત ફોલો-અપ — જેથી વર્ષો સુધી સ્થિરતા રહે." },
  { icon: HeartPulse, title: "ચિંતા અને પેનિક એટેક", signs: "સતત ચિંતા, બેચેની, છાતીમાં ધડકન, શ્વાસ ચઢવો, છાતીમાં દબાણ, મરી જવાનો ડર, ભીડ કે મુસાફરી ટાળવી.", care: "પેનિકના મોટાભાગના દર્દીઓ પહેલાં હૃદયરોગના ડૉક્ટર પાસે જાય છે. ECG નોર્મલ આવે પછી CBT થેરાપી અને જરૂર પડે તો દવાથી ૮થી ૧૨ અઠવાડિયામાં સામાન્ય જીવન શક્ય છે." },
  { icon: Repeat, title: "OCD (વળગણ–વિધિ)", signs: "વારંવાર હાથ ધોવા, તાળું–ગેસ ચેક કરવા, ગણતરી કરવી, ન જોઈતા ખરાબ વિચારો, દરરોજના કલાકો વિધિઓમાં જવા.", care: "વધુ ડોઝની SSRI દવા સાથે ERP થેરાપી. દવા અસર ન કરે તેવા કિસ્સામાં FDA માન્ય rTMS — ભાવનગરમાં અમારી પોતાની ન્યુરોમોડ્યુલેશન સુવિધામાં." },
  { icon: Brain, title: "સ્કીઝોફ્રેનિયા અને માનસિક ભ્રમ", signs: "આવાજ સંભળાવા, શંકા–વહેમ, ખોટી માન્યતાઓ, એકલા બોલવું, સમાજથી અળગા રહેવું, પોતાની સંભાળ ન લેવી.", care: "વહેલી શરૂ થતી દવા, ગોળી નિયમિત ન લેવાય તો લાંબા સમય ચાલતું ઈન્જેક્શન, પરિવારને સમજ અને કામ પર પરત ફરવાની તૈયારી. જેટલી વહેલી સારવાર, તેટલું સારું પરિણામ." },
  { icon: Sparkles, title: "તણાવ અને પરિસ્થિતિજન્ય વિકાર", signs: "સ્વજનની ખોટ, પરીક્ષામાં નિષ્ફળતા, નોકરી કે ધંધામાં નુકસાન, અકસ્માત કે સંબંધ તૂટ્યા પછીની અસહ્ય પ્રતિક્રિયા.", care: "ટૂંકા ગાળાની OPD સારવાર — કાઉન્સેલિંગ, ઊંઘ સુધારવી અને જરૂર પૂરતી દવા. ઘણા દર્દીઓને ફક્ત થોડી મુલાકાતો પૂરતી હોય છે." },
  { icon: Moon, title: "અનિદ્રા અને ઊંઘની તકલીફ", signs: "ઊંઘ ન આવવી કે વારંવાર તૂટવી, સવારે તાજગી ન લાગવી, દિવસે થાક, ઊંઘની ગોળીઓની આદત.", care: "ફક્ત ગોળી નહીં — કારણની સારવાર. CBT-I થેરાપી, સ્લીપ એપ્નિયા–થાઈરોઈડની તપાસ, અને વર્ષોથી ચાલતી ઊંઘની ગોળી સુરક્ષિત રીતે છોડાવવાની યોજના." },
  { icon: Stethoscope, title: "શરીરમાં દુખાવો અને તણાવજન્ય માથાનો દુખાવો", signs: "રિપોર્ટ નોર્મલ હોવા છતાં શરીરમાં દુખાવો, બળતરા, ચક્કર, માથાનો દુખાવો, માઈગ્રેન.", care: "આ તકલીફો સાચી છે અને તેનું મૂળ મગજ–ચેતાતંત્રમાં હોય છે. યોગ્ય દવા, રિલેક્સેશન તાલીમ અને સ્પષ્ટ સમજ — હવે વારંવાર રિપોર્ટ કઢાવવાની જરૂર નહીં." },
  { icon: Users, title: "ડિમેન્શિયા અને વૃદ્ધાવસ્થાની માનસિક સંભાળ", signs: "ભૂલી જવું, એક જ પ્રશ્ન વારંવાર પૂછવો, રસ્તો ભૂલી જવો, ઘરના પર શંકા, રાત્રે બેચેની, ઉંમરલાયક વયે હતાશા.", care: "યાદશક્તિની તપાસ, સારી થઈ શકે તેવાં કારણોની ચકાસણી, જરૂરી દવા — અને સૌથી મહત્વનું, સંભાળ રાખનાર પરિવારને તાલીમ." },
  { icon: Baby, title: "બાળકો અને કિશોરોની માનસિક સારવાર", signs: "ધ્યાન ન ટકવું (ADHD), ઓટિઝમની શંકા, શાળાએ જવાની ના, પરિણામ બગડવું, ગુસ્સો–તોડફોડ, પથારીમાં પેશાબ, પરીક્ષાનો ડર.", care: "માતા-પિતા અને શિક્ષક સાથે મળીને થતી OPD સારવાર. મુખ્યત્વે વર્તન-આધારિત ઉપચાર; દવા ખરેખર જરૂરી હોય ત્યારે જ અને સમજાવીને." },
  { icon: Flower2, title: "સ્ત્રીઓનું માનસિક સ્વાસ્થ્ય", signs: "પ્રસૂતિ પછીની હતાશા, માસિક પહેલાંનો તીવ્ર મૂડ બદલાવ (PMDD), મેનોપોઝની ચિંતા–અનિદ્રા, સંતાન ન થવાનો તણાવ.", care: "ગર્ભાવસ્થા અને સ્તનપાનમાં સલામત દવાની પસંદગી, જરૂર પડે તો તમારા ગાયનેક ડૉક્ટર સાથે સંકલન — સંપૂર્ણ ખાનગી પરામર્શમાં." },
  { icon: LifeBuoy, title: "આપઘાતનું જોખમ અને તાત્કાલિક સંભાળ", signs: "\"હું બોજ છું\" એવી વાત, પોતાની વસ્તુઓ વહેંચી દેવી, ઘોર નિરાશા, પહેલાં પ્રયાસ કરેલો હોવો, ભારે તણાવ પછી અચાનક શાંતિ.", care: "આ ઈમર્જન્સી છે, ટાળવાની વાત નથી. +૯૧ ૯૪૨૭૫ ૬૦૧૦૧ પર ફોન કરો — તે જ દિવસે તપાસ, સુરક્ષા યોજના અને જરૂર પડે તો ઝડપી અસર કરતી કિટામિન થેરાપી." },
];

const why = [
  { icon: CalendarClock, title: "એ જ અઠવાડિયામાં OPD સમય", desc: "રેફરલ ચિઠ્ઠીની જરૂર નથી. સોમથી શનિ, સવારે ૯ થી રાત્રે ૮ — રૂબરૂ આવો, ફોન કરો કે ઓનલાઈન સમય લો." },
  { icon: Stethoscope, title: "MD તજજ્ઞ મનોચિકિત્સકો", desc: "ડૉ. કમલેશ એ. શાહ (MD, ૧૯૮૯થી) અને ડૉ. ધર્મિન કે. શાહ (MD, TMS ફિઝિશિયન — AIIMS, નવી દિલ્હી) દ્વારા પરામર્શ." },
  { icon: IndianRupee, title: "સ્પષ્ટ અને વાજબી ફી", desc: "સામાન્ય કન્સલ્ટેશન ફી. કોઈ પેકેજ નહીં, બિનજરૂરી રિપોર્ટ નહીં, દાખલ થવાનું દબાણ નહીં." },
  { icon: ShieldCheck, title: "સંપૂર્ણ ગોપનીયતા", desc: "તમારી લેખિત મંજૂરી વગર તમારી માહિતી પરિવાર, નોકરીદાતા કે કોઈને પણ આપવામાં આવતી નથી." },
];

const steps = [
  { t: "પગલું ૧ — સમય લેવો", d: "ફોન કરો, રૂબરૂ આવો કે વેબસાઈટ પરથી સમય માંગો. સામાન્ય OPD માટે રેફરલ કે લાંબી વેઇટિંગ નથી." },
  { t: "પગલું ૨ — તપાસ", d: "૪૫થી ૬૦ મિનિટનો પરામર્શ: સંપૂર્ણ ઇતિહાસ, માનસિક સ્થિતિની તપાસ અને જરૂર પડે તો શારીરિક કારણ શોધવા લોહીની તપાસ." },
  { t: "પગલું ૩ — નિદાન સમજાવવું", d: "તમને ગુજરાતીમાં સ્પષ્ટ કહેવામાં આવે છે કે તકલીફ શું છે — અને શું નથી. પરિવારને તમે ઇચ્છો તો જ સામેલ કરાય છે." },
  { t: "પગલું ૪ — સારવારની યોજના", d: "જ્યાં ખરેખર જરૂરી હોય ત્યાં દવા, જ્યાં થેરાપી વધુ કામ કરે ત્યાં થેરાપી, અને ઊંઘ–જીવનશૈલીમાં સુધારો. ખર્ચ અને સમયગાળો પહેલેથી જણાવાય છે." },
  { t: "પગલું ૫ — ફોલો-અપ", d: "શરૂઆતમાં દર ૨થી ૪ અઠવાડિયે તપાસ, સુધારો થતાં અંતર વધારવામાં આવે. દવા ઘટાડવી કે બંધ કરવી પણ યોજનાપૂર્વક થાય છે." },
];

const faqs = [
  { q: "મનોચિકિત્સકને મળવા માટે રેફરલ ચિઠ્ઠી જરૂરી છે?", a: "ના. કોઈ રેફરલની જરૂર નથી. તમે OPD સમય દરમિયાન (સોમથી શનિ, સવારે ૯ થી રાત્રે ૮) સીધા આવી શકો, +૯૧ ૯૪૨૭૫ ૬૦૧૦૧ પર ફોન કરી શકો કે આ વેબસાઈટ પરથી સમય માંગી શકો." },
  { q: "કઈ માનસિક તકલીફો દાખલ થયા વગર, OPDમાં જ મટે છે?", a: "લગભગ બધી જ — હતાશા, ચિંતા અને પેનિક, OCD, અનિદ્રા, સ્થિર બાયપોલર, તણાવજન્ય વિકાર, બાળકોની વર્તન સમસ્યા, ADHD, ડિમેન્શિયાની સંભાળ, પ્રસૂતિ પછીની હતાશા અને શરીરના દુખાવા. દાખલ થવાની જરૂર ફક્ત ગંભીર માનસિક ભ્રમ, આપઘાતના ઊંચા જોખમ કે વ્યસનમુક્તિની સારવારમાં પડે છે." },
  { q: "દવા જીવનભર લેવી પડશે?", a: "સામાન્ય રીતે નહીં. ચિંતા, હતાશા, અનિદ્રા અને તણાવજન્ય તકલીફોમાં દવા મહિનાઓ માટે હોય છે, પછી ધીમે ધીમે બંધ કરાય છે. બાયપોલર અને સ્કીઝોફ્રેનિયા જેવી બીમારીઓમાં ફરી હુમલો ટાળવા લાંબા ગાળાની દવા જરૂરી હોય છે — અને તેનું કારણ શરૂ કરતાં પહેલાં સમજાવવામાં આવે છે." },
  { q: "સારવાર ખાનગી રહેશે? ઘરના કે નોકરીદાતાને ખબર પડશે?", a: "સંપૂર્ણ ખાનગી. તમારી લેખિત મંજૂરી વગર કોઈને પણ માહિતી આપવામાં આવતી નથી." },
  { q: "શું માનસિક બીમારીની દવાથી શરીર બગડે છે કે નબળાઈ આવે છે?", a: "આજની દવાઓ સુરક્ષિત છે અને યોગ્ય ડોઝમાં વર્ષો સુધી લઈ શકાય છે. કોઈ પણ સંભવિત આડઅસર શરૂ કરતાં પહેલાં જણાવાય છે અને દરેક ફોલો-અપમાં તપાસાય છે. સારવાર ન લેવાનું જોખમ દવાના જોખમ કરતાં ઘણું વધારે છે." },
  { q: "હું મારા વૃદ્ધ માતા-પિતા કે બાળકને લાવી શકું?", a: "હા. અમે બાળકોથી વૃદ્ધો સુધી — બાળ–કિશોર માનસિક સારવાર અને ડિમેન્શિયા સહિતની વૃદ્ધાવસ્થાની સંભાળ — બધી ઉંમરના દર્દીઓની સારવાર કરીએ છીએ." },
  { q: "પહેલાં દવા લીધી પણ હતાશા મટી નહીં, હવે શું?", a: "આ સ્થિતિ માટે જ અમારી ન્યુરોમોડ્યુલેશન સુવિધા છે — સારવારને ન ગાંઠતી હતાશા અને OCD માટે rTMS, tDCS અને કિટામિન ઈન્ફ્યુઝન, ભાવનગરમાં જ ઉપલબ્ધ." },
  { q: "કોઈ આપઘાતની વાત કરે તો શું કરવું?", a: "તેને તબીબી ઈમર્જન્સી ગણો અને તરત +૯૧ ૯૪૨૭૫ ૬૦૧૦૧ પર ફોન કરો. અમે તે જ દિવસે તપાસ અને તાત્કાલિક સંભાળ આપીએ છીએ." },
];

const JSONLD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "MedicalClinic",
      "@id": `${SITE}/#clinic`,
      name: "માનસ ન્યુરોસાઇકિયાટ્રી હોસ્પિટલ, ભાવનગર",
      alternateName: "Manas Neuropsychiatry Hospital",
      medicalSpecialty: "Psychiatry",
      inLanguage: "gu-IN",
      url: `${SITE}/gu/general-psychiatry`,
      telephone: "+91-94275-60101",
      foundingDate: "1989",
      address: {
        "@type": "PostalAddress",
        streetAddress: "2nd floor, Carlton Square, Near Madhavdeep Complex, Kalanala",
        addressLocality: "Bhavnagar",
        postalCode: "364001",
        addressRegion: "Gujarat",
        addressCountry: "IN",
      },
      areaServed: ["Bhavnagar", "Sihor", "Palitana", "Talaja", "Mahuva", "Botad", "Amreli", "Saurashtra", "Gujarat"],
      openingHoursSpecification: [{
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        opens: "09:00",
        closes: "20:00",
      }],
    },
    {
      "@type": "FAQPage",
      inLanguage: "gu-IN",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};

export default function GeneralPsychiatryGu() {
  useSEO({
    title: "ભાવનગરમાં મનોચિકિત્સક · સામાન્ય માનસિક રોગોની OPD સારવાર",
    description:
      "ભાવનગરની માનસ ન્યુરોસાઇકિયાટ્રી હોસ્પિટલ (૧૯૮૯થી) — ડિપ્રેશન, ચિંતા અને પેનિક એટેક, OCD, બાયપોલર, સ્કીઝોફ્રેનિયા, અનિદ્રા, ADHD, ડિમેન્શિયા, પ્રસૂતિ પછીની હતાશા અને આપઘાતના વિચારોની OPD સારવાર. રેફરલ જરૂરી નથી. ડૉ. કમલેશ શાહ અને ડૉ. ધર્મિન શાહ. ફોન +૯૧ ૯૪૨૭૫ ૬૦૧૦૧.",
    image: HERO,
    jsonLd: JSONLD,
    lang: "gu",
    alternates: [
      { hreflang: "en-IN", href: `${SITE}/general-psychiatry` },
      { hreflang: "gu-IN", href: `${SITE}/gu/general-psychiatry` },
      { hreflang: "x-default", href: `${SITE}/general-psychiatry` },
    ],
  });
  const [open, setOpen] = useState(false);

  return (
    <div data-testid="general-psychiatry-gu-page">
      {/* HERO */}
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-12 md:pt-20 pb-16">
        <div className="flex items-center gap-3 mb-6 flex-wrap">
          <p className="eyebrow text-[#A39171]">સામાન્ય માનસિક રોગો · OPD</p>
          <Link
            to="/general-psychiatry"
            data-testid="gu-switch-english"
            className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border border-[#A39171]/40 text-[#5C524E] hover:border-[#E07A5F] hover:text-[#E07A5F] transition-colors"
          >
            <Languages className="w-3.5 h-3.5" /> Read in English
          </Link>
        </div>
        <h1 className="font-display text-4xl md:text-6xl text-[#2D2623] leading-[1.1] tracking-tight max-w-4xl">
          મન બીમાર પડે ત્યારે <br />
          <span className="italic text-[#E07A5F]">દાખલ થવાની જરૂર નથી</span> — સારા ડૉક્ટરની છે.
        </h1>
        <p className="mt-8 text-lg md:text-xl text-[#5C524E] max-w-3xl leading-relaxed">
          ભાવનગરની માનસ હોસ્પિટલની રોજિંદી માનસિક રોગોની OPD — હતાશા, ચિંતા અને પેનિક એટેક, OCD,
          અનિદ્રા, બાયપોલર, માનસિક ભ્રમ, બાળકોની વર્તન સમસ્યાઓ, વૃદ્ધોની યાદશક્તિની તકલીફ અને
          સ્ત્રીઓનું માનસિક સ્વાસ્થ્ય. યોગ્ય નિદાન, દાખલ થયા વગરની સારવાર, અને સાજા થાઓ ત્યાં સુધી
          ફોલો-અપ.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <Button data-testid="gu-hero-book" onClick={() => setOpen(true)} className="rounded-full bg-[#2D2623] hover:bg-[#E07A5F] text-[#FDFBF7] px-8 h-14 font-medium">
            OPD સમય માંગો <ArrowUpRight className="ml-1 w-4 h-4" />
          </Button>
          <a href="tel:+919427560101" data-testid="gu-hero-call" className="rounded-full border border-[#2D2623]/20 hover:border-[#E07A5F] hover:text-[#E07A5F] text-[#2D2623] px-8 h-14 inline-flex items-center justify-center font-medium transition-colors">
            ફોન કરો +૯૧ ૯૪૨૭૫ ૬૦૧૦૧
          </a>
        </div>
        <p className="mt-6 text-sm text-[#A39171]">
          સોમથી શનિ · સવારે ૯ થી રાત્રે ૮ · કાળાનાળા, ભાવનગર · રેફરલ જરૂરી નથી · ઈમર્જન્સી ૨૪×૭
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 mb-24">
        <div className="rounded-3xl overflow-hidden aspect-[16/9] md:aspect-[21/9] relative">
          <img src={HERO} alt="ભાવનગરની માનસ હોસ્પિટલમાં મનોચિકિત્સક દર્દી સાથે પરામર્શ કરે છે" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1A1513]/90 via-[#1A1513]/45 to-transparent" />
          <div className="absolute bottom-8 left-8 right-8 md:left-12 md:right-auto md:max-w-xl">
            <p className="eyebrow text-[#F0CF5B] mb-3 drop-shadow-[0_2px_8px_rgba(0,0,0,0.65)]">૧૯૮૯થી સૌરાષ્ટ્રની સેવામાં</p>
            <p className="font-display text-2xl md:text-3xl leading-snug text-white drop-shadow-[0_2px_10px_rgba(0,0,0,0.7)]">
              બે પેઢીના મનોચિકિત્સકો, એક લાખથી વધુ પરામર્શ.
            </p>
          </div>
        </div>
      </section>

      {/* CONDITIONS */}
      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="max-w-3xl mb-14">
            <p className="eyebrow text-[#A39171] mb-4">OPDમાં સારવાર થતી તકલીફો</p>
            <h2 className="font-display text-3xl md:text-5xl text-[#2D2623] tracking-tight leading-snug">
              લોકો અમારી પાસે આવે તેવાં <span className="italic text-[#E07A5F]">બાર સામાન્ય કારણો</span>.
            </h2>
            <p className="mt-6 text-lg text-[#5C524E] leading-relaxed">
              નીચેની લગભગ દરેક તકલીફની સારવાર દાખલ થયા વગર થાય છે — તમે આવો, તપાસ થાય, અને સારવારની
              યોજના સાથે ઘરે જાઓ. દાખલ થવું અપવાદ છે, નિયમ નહીં.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {conditions.map((c, i) => (
              <article key={c.title} data-testid={`gu-condition-${i}`}
                className="bg-[#F4EFE6] rounded-3xl p-8 md:p-9 border border-[#A39171]/15 hover:shadow-[0_20px_50px_rgba(163,145,113,0.14)] transition-shadow">
                <span className="w-12 h-12 rounded-2xl bg-[#2D2623] text-[#FDFBF7] flex items-center justify-center mb-5">
                  <c.icon className="w-5 h-5" />
                </span>
                <h3 className="font-display text-2xl md:text-3xl text-[#2D2623] tracking-tight leading-snug">{c.title}</h3>
                <p className="mt-4 text-[#5C524E] leading-relaxed">
                  <span className="text-xs uppercase tracking-[0.16em] text-[#A39171] block mb-1.5">લક્ષણો</span>
                  {c.signs}
                </p>
                <p className="mt-4 text-[#2D2623] leading-relaxed">
                  <span className="text-xs uppercase tracking-[0.16em] text-[#A39171] block mb-1.5">અમારી સારવાર</span>
                  {c.care}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* WHY US */}
      <section className="bg-[#F4EFE6]/60 py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <p className="eyebrow text-[#A39171] mb-4">દર્દીઓ માનસ કેમ પસંદ કરે છે</p>
          <h2 className="font-display text-3xl md:text-5xl text-[#2D2623] tracking-tight mb-14 max-w-3xl leading-snug">
            સમયસર ચાલતી અને <span className="italic text-[#E07A5F]">પુરાવા આધારિત</span> માનસિક OPD.
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
            {why.map((w, i) => (
              <div key={w.title} data-testid={`gu-why-${i}`}
                className="bg-[#FDFBF7] rounded-3xl p-7 border border-[#A39171]/15 hover:border-[#E07A5F]/40 transition-all">
                <span className="w-12 h-12 rounded-2xl bg-[#E07A5F] text-white flex items-center justify-center mb-5">
                  <w.icon className="w-5 h-5" />
                </span>
                <h3 className="font-display text-xl text-[#2D2623] leading-snug">{w.title}</h3>
                <p className="text-[#5C524E] mt-2 text-sm leading-relaxed">{w.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* STEPS */}
      <section className="py-24 md:py-32">
        <div className="max-w-5xl mx-auto px-6 md:px-10">
          <p className="eyebrow text-[#A39171] mb-4">શું અપેક્ષા રાખવી</p>
          <h2 className="font-display text-3xl md:text-5xl text-[#2D2623] tracking-tight mb-14 leading-snug">તમારી OPD મુલાકાત, પગલું દર પગલું.</h2>
          <ol className="space-y-10">
            {steps.map((s, i) => (
              <li key={s.t} data-testid={`gu-step-${i}`} className="grid grid-cols-12 gap-6 border-b border-[#A39171]/15 pb-10 last:border-none">
                <div className="col-span-12 md:col-span-3">
                  <span className="font-display text-4xl text-[#E07A5F]">0{i + 1}</span>
                </div>
                <div className="col-span-12 md:col-span-9">
                  <h3 className="font-display text-2xl md:text-3xl text-[#2D2623] tracking-tight leading-snug">{s.t}</h3>
                  <p className="text-[#5C524E] mt-3 text-lg leading-relaxed">{s.d}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* CROSS LINKS */}
      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="bg-[#2D2623] text-[#FDFBF7] rounded-3xl p-8 md:p-14 relative overflow-hidden">
            <div className="absolute inset-0 grain opacity-30 pointer-events-none" />
            <div className="relative grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
              <div className="md:col-span-7">
                <p className="eyebrow text-[#E2C044] mb-4">OPD ઉપરાંત</p>
                <h2 className="font-display text-2xl md:text-4xl tracking-tight leading-snug">
                  ફક્ત ગોળીઓથી કામ ન થયું હોય, તો હજુ ઘણું થઈ શકે છે.
                </h2>
                <p className="text-[#FDFBF7]/75 mt-5 leading-relaxed">
                  સામાન્ય માનસિક OPD સાથે rTMS, tDCS અને કિટામિન ઈન્ફ્યુઝન આપતું આ પ્રદેશનું એકમાત્ર
                  કેન્દ્ર — સાથે તબીબી દેખરેખ હેઠળનો વ્યસનમુક્તિ કાર્યક્રમ અને ખાનગી સેક્સોલોજી ક્લિનિક.
                </p>
              </div>
              <div className="md:col-span-5 flex flex-col gap-3">
                <Link to="/neuromodulation" data-testid="gu-link-neuromodulation" className="rounded-2xl bg-[#FDFBF7]/5 border border-[#FDFBF7]/15 hover:bg-[#E07A5F] px-6 py-4 flex items-center justify-between transition-colors">
                  <span className="font-medium">દવાને ન ગાંઠતી હતાશા અને OCD</span>
                  <ArrowUpRight className="w-4 h-4 shrink-0" />
                </Link>
                <Link to="/deaddiction" data-testid="gu-link-deaddiction" className="rounded-2xl bg-[#FDFBF7]/5 border border-[#FDFBF7]/15 hover:bg-[#E07A5F] px-6 py-4 flex items-center justify-between transition-colors">
                  <span className="font-medium">દારૂ, તમાકુ અને ડ્રગ્સથી મુક્તિ</span>
                  <ArrowUpRight className="w-4 h-4 shrink-0" />
                </Link>
                <Link to="/sexology" data-testid="gu-link-sexology" className="rounded-2xl bg-[#FDFBF7]/5 border border-[#FDFBF7]/15 hover:bg-[#E07A5F] px-6 py-4 flex items-center justify-between transition-colors">
                  <span className="font-medium">જાતીય સ્વાસ્થ્ય અને લૈંગિક સમસ્યાઓ</span>
                  <ArrowUpRight className="w-4 h-4 shrink-0" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-[#F4EFE6]/60 py-24 md:py-32">
        <div className="max-w-5xl mx-auto px-6 md:px-10">
          <p className="eyebrow text-[#A39171] mb-4">વારંવાર પૂછાતા પ્રશ્નો</p>
          <h2 className="font-display text-3xl md:text-5xl text-[#2D2623] tracking-tight mb-14 max-w-3xl leading-snug">
            આવતાં પહેલાં જાણવા જેવું.
          </h2>
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem key={f.q} value={`gu-${i}`} data-testid={`gu-faq-${i}`}
                className="bg-[#FDFBF7] rounded-2xl border border-[#A39171]/15 px-6 data-[state=open]:border-[#E07A5F]/35 transition-colors">
                <AccordionTrigger className="text-left font-display text-lg md:text-2xl text-[#2D2623] tracking-tight hover:no-underline py-5 leading-snug">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#5C524E] text-base md:text-lg leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* AREAS */}
      <section className="py-20 md:py-24">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <p className="eyebrow text-[#A39171] mb-4">દર્દીઓ ક્યાંથી આવે છે</p>
          <h2 className="font-display text-2xl md:text-4xl text-[#2D2623] tracking-tight leading-snug">
            ભાવનગર અને સમગ્ર સૌરાષ્ટ્ર માટેની માનસિક રોગોની OPD.
          </h2>
          <p className="mt-6 text-[#5C524E] leading-relaxed max-w-3xl mx-auto">
            ભાવનગર શહેર, સિહોર, પાલીતાણા, તળાજા, મહુવા, ગારીયાધાર, બોટાદ, અમરેલી, રાજકોટ, સુરત અને
            સમગ્ર ગુજરાતમાંથી દર્દીઓ માનસિક તપાસ, વ્યસનમુક્તિ અને ન્યુરોમોડ્યુલેશન સારવાર માટે
            કાળાનાળા સ્થિત માનસ ન્યુરોસાઇકિયાટ્રી હોસ્પિટલ આવે છે.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#2D2623] text-[#FDFBF7] py-20 md:py-24 relative overflow-hidden">
        <div className="absolute inset-0 grain opacity-30 pointer-events-none" />
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center relative">
          <h2 className="font-display text-3xl md:text-5xl tracking-tight leading-snug">
            મદદ મેળવવા માટે <span className="italic text-[#E07A5F]">પરિસ્થિતિ બગડવાની વાટ ન જુઓ</span>.
          </h2>
          <p className="text-[#FDFBF7]/70 mt-5 max-w-xl mx-auto">
            આજે જ માનસિક પરામર્શ માટે સમય લો — સોમથી શનિ, સવારે ૯ થી રાત્રે ૮.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Button data-testid="gu-cta-book" onClick={() => setOpen(true)} className="rounded-full bg-[#E07A5F] hover:bg-[#FDFBF7] hover:text-[#2D2623] text-white px-8 h-12 font-medium">સમય માંગો</Button>
            <a href="tel:+919427560101" className="rounded-full border border-[#FDFBF7]/30 hover:bg-[#FDFBF7] hover:text-[#2D2623] px-8 h-12 inline-flex items-center justify-center font-medium transition-colors">ફોન +૯૧ ૯૪૨૭૫ ૬૦૧૦૧</a>
          </div>
        </div>
      </section>

      <AppointmentDialog open={open} onOpenChange={setOpen} />
    </div>
  );
}
